import s from "./Notes.module.scss";

const noteColumns = [
  {
    icon: "bag",
    title: "持ち物",
    items: [
      "水着",
      "タオル",
      "日焼け止め",
      "サングラス・帽子",
      "酔い止め（必要な方）",
    ],
  },
  {
    icon: "alert",
    title: "注意事項",
    items: [
      "最少催行人数：1名",
      "天候によりスケジュールが変更になる場合があります",
    ],
  },
  {
    icon: "calendar",
    title: "キャンセルポリシー",
    items: ["48時間前まで：無料", "24時間前まで：50%", "24時間以内：100%"],
  },
];

const NoteIcon = ({ type }) => {
  if (type === "bag") {
    return (
      <svg viewBox="0 0 24 24">
        <path d="M6 8h12l1 12H5L6 8z" />
        <path d="M9 8V6a3 3 0 0 1 6 0v2" />
      </svg>
    );
  }

  if (type === "alert") {
    return (
      <svg viewBox="0 0 24 24">
        <path d="M12 3l10 18H2L12 3z" />
        <path d="M12 9v5" />
        <path d="M12 17h.01" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24">
      <rect x="4" y="5" width="16" height="15" rx="3" />
      <path d="M8 3v4" />
      <path d="M16 3v4" />
      <path d="M4 10h16" />
    </svg>
  );
};

const WaveIcon = () => (
  <svg className={s.wave} viewBox="0 0 58 10">
    <path d="M1 5C5 1 9 1 13 5C17 9 21 9 25 5C29 1 33 1 37 5C41 9 45 9 49 5C52 2 55 2 57 5" />
  </svg>
);

const Notes = ({ columns = noteColumns }) => {
  return (
    <section className={s.root}>
      <div className={s.head}>
        <h2 className={s.title}>
          注意事項
          <WaveIcon />
        </h2>
      </div>

      <div className={s.columns}>
        {columns.map((column) => (
          <div className={s.column} key={column.title}>
            <div className={s.icon}>
              <NoteIcon type={column.icon} />
            </div>

            <div>
              <h3>{column.title}</h3>

              <ul>
                {column.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Notes;
